import { useQuery } from "react-query";
import { navigate } from "gatsby";
import { getcompanyDomain } from "../utils";
import { getCompanyInfo } from "../api/company";
import { applyTenantTheme } from "../utils/theme-utils";

const changeFavicon = (iconUrl) => {
  // Remove all existing favicons
  document
    .querySelectorAll("link[rel='icon']")
    .forEach((icon) => icon.remove());

  // Add new favicon
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = iconUrl;
  document.head.appendChild(link);
};

/**
 * * The returned data can be simply an { message: "OK" } if user is querying from the root backoffice.
 */
export const useCompanyInfo = () => {
  const companyDomain = getcompanyDomain();
  return useQuery(
    ["companyInfo", companyDomain],
    () =>
      getCompanyInfo({
        params: { domain: companyDomain },
      }),
    {
      onSuccess: (data) => {
        applyTenantTheme({
          primaryColor: data?.theme?.primaryColor,
          secondaryColor: data?.theme?.secondaryColor,
        });
        if (data?.theme?.iconUrl) {
          changeFavicon(data.theme.iconUrl);
        }
      },
      onError: (error) => {
        if (error.status === 404) {
          navigate("/page-error");
        }
        if (error.status === 403) {
          navigate("/waiting-for-approval");
        }
      },
      retry: (_, error) => {
        if (error.status === 403) {
          return false;
        }
        return 1;
      },
      refetchOnWindowFocus: false,
    }
  );
};

export const useCompanyInfoById = (companyId) => {
  return useQuery(
    ["companyInfo", companyId],
    () =>
      getCompanyInfo({
        params: { companyId },
      }),
    {
      enabled: !!companyId,
      onError: (error) => {
        if (error.status === 404) {
          navigate("/page-error");
        }
      },
      retry: 1,
    }
  );
};

export const useCompanyTheme = () => {
  const { data: companyInfo } = useCompanyInfo();
  return companyInfo?.theme || {};
};

export const useCompanyLogo = () => {
  const companyTheme = useCompanyTheme();
  const companyLightLogo = companyTheme?.logoUrl || companyTheme?.iconUrl;
  const companyDarkLogo =
    companyTheme?.logoDarkUrl || companyTheme?.iconDarkUrl;
  return {
    lightLogo: companyLightLogo,
    darkLogo: companyDarkLogo,
  };
};
